<template>
    <!-- 页尾 -->
    <div class="footer">
        <div class="footer-link">
            <a target="_blank" href="http://corp.huanqiu.com/about/">环球网简介</a>
            <b>|</b>
            <a target="_blank" href="https://corp.huanqiu.com/aboutus/">About huanqiu.com</a>
            <b>|</b>
            <a target="_blank" href="https://www.huanqiu.com/sitemap">网站地图</a>
            <b>|</b>
            <a target="_blank" href="http://corp.huanqiu.com/jobs/">诚聘英才</a>
            <b>|</b>
            <a target="_blank" href="http://corp.huanqiu.com/advertising_services/">广告服务</a>
            <b>|</b>
            <a target="_blank" href="http://corp.huanqiu.com/contactus/">联系方式</a>
            <b>|</b>
            <a target="_blank" href="http://corp.huanqiu.com/privacy_policy/">隐私政策</a>
            <b>|</b>
            <a target="_blank" href="http://corp.huanqiu.com/terms/">服务条款</a>
            <b>|</b>
            <a target="_blank" href="mailto:jubao@huanqiu.com">意见反馈</a>
            <b>|</b>
            <a href="//www.huanqiu.com/globaltimes" target="_blank">环球时报系产品</a>
        </div>
        <div class="copyright">© 环球网 版权所有</div>
    </div>
</template>

<script>
export default {
  name: "app-footer",
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeCreate() {}
};
</script>
<style lang='scss' scoped>

/* 页尾 */

.footer {
    margin: 0 auto;
    width: 1000px;
    height: 53px;
    padding-bottom: 27px;
    // background: #ffffff;
}

.footer .footer-link {
    text-align: center;
    overflow: hidden;
    color: #919191;
    height: 26px;
    line-height: 34px;
    font-size: 12px;
}

.footer .footer-link a {
    color: #919191;
    text-decoration: none;
}

.footer .footer-link a:active,
.footer .footer-link a:hover {
    background: 0 0;
    text-decoration: underline;
}

.footer .footer-link b {
    padding: 0 10px;
    font-weight: 400;
}

.footer .copyright {
    width: 1000px;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    color: #919191;
    height: 26px;
    line-height: 34px;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/footer.vue